import React, {useState, useEffect } from 'react'
import {
  Box
} from '@mui/material';
import ProjectCount from '../../../components/common/projectCount/ProjectCount';
import { useDispatch, useSelector } from 'react-redux';
import { getProjectCounts } from '../../../modules/auth';



const ProjectCounterContainer = () => {
  const dispatch = useDispatch();
  const [prjCounts, setprjCounts] = useState([]);
  const { projectCounts } = useSelector(({ auth }) => ({
    projectCounts: auth.projectCounts,
  }));

  useEffect(() => {
    dispatch(getProjectCounts());
  }, [dispatch]);

  useEffect(() => {
    if(projectCounts){
      setprjCounts(projectCounts)
    }
  }, [projectCounts])
  
    
    // useInterval(() => {
    //     // Your custom logic here
    //     //console.log('currentIndex',currentIndex);
    //     getCountData();
      
    //   }, 1000 * 60 ); //1분마다

    // const getCountData = ()=>{
    //     //console.log(currentIndex,'currentIndex')
    //     if(currentIndex < prjCounts.length){
    //         setCountData(prjCounts[currentIndex]);
    //         setCurrentIndex(currentIndex+1);
    //     }else{
    //         setCurrentIndex(0);
    //     }
       
    // }
    

  return (
    <Box sx={{display:'flex', justifyContent:'flex-start', alignItems:'center'}}>
      {prjCounts.map((prj, index)=>(
        <ProjectCount project={prj} key={index}/>
      ))}
    </Box>
  )
}

export default ProjectCounterContainer